import { useIsMobile } from '@sravni/react-utils';

import { CHANNELS } from 'shared/config';

import { useAppSelector } from '../../../shared/lib/redux';
import { selectIsWaybackRestorePage, selectIsWlAnketaPage } from '../model/siteSettings.selectors';

export const useChannel = () => {
  const isMobile = useIsMobile();

  const isWaybackRestorePage = useAppSelector(selectIsWaybackRestorePage);
  const isWL = useAppSelector(selectIsWlAnketaPage);

  if (isWaybackRestorePage) {
    return CHANNELS.FRONTEND_WAYBACK_LINK;
  }

  if (isWL) {
    return CHANNELS.WL;
  }

  if (isMobile) {
    return CHANNELS.MOBILE_WEB;
  }

  return CHANNELS.DESKTOP;
};
